import { useLayoutEffect } from 'react';
import { useSSR } from '../components/ssr-provider';

export const useIsomorphicLayoutEffect: typeof useLayoutEffect = (...args) => {
  const { isServer } = useSSR();
  return isServer ? () => {} : useLayoutEffect(...args);
};
